import React from 'react';
import { injectV2 } from '../../../injectV2';
import { RoutingStore } from '../../../stores/RoutingStore';
import { Category } from '../../../../../types/api';
import { RouteLocation } from '../../../stores/routes/createRoute';
import s from './ForYouCategoriesList.scss';
import { CategoriesListItem } from './CategoriesListItem/CategoriesListItem';
import { forYouCategoriesListDataHooks } from './ForYouCategoriesList.dataHooks';

interface CategoryTagListProps {
  categories: Category[];
  routingStore: RoutingStore;
  dataHook?: string;
}

const ForYouCategoriesListCmp: React.FC<CategoryTagListProps> = (props) => {
  const { categories, dataHook, routingStore } = props;
  const getCategoryLink = (category: Category): RouteLocation => {
    return routingStore.locationBuilders.category({ categorySlug: category.name });
  };

  return (
    <nav className={s.root} data-hook={dataHook}>
      <ul className={s.list}>
        {categories.map((category, index) => (
          <CategoriesListItem
            title={category.displayName}
            slug={category.name}
            location={getCategoryLink(category)}
            key={category.name}
            dataHook={forYouCategoriesListDataHooks.listItem({ slug: category.name })}
          />
        ))}
      </ul>
    </nav>
  );
};

export const ForYouCategoriesList = injectV2('routingStore')(ForYouCategoriesListCmp);
